module.exports = __webpack_public_path__ + "static/media/craniosacral-desktop.f1c7e097.jpg";